export default __webpack_public_path__ + "static/NanumPenScript-Regular-df2d3cefa0e2a81252874b88f2c3cc6a.woff2";